import { render, staticRenderFns } from "./TwIpDnDetailInner.vue?vue&type=template&id=17afb31e&scoped=true&"
import script from "./TwIpDnDetailInner.vue?vue&type=script&lang=js&"
export * from "./TwIpDnDetailInner.vue?vue&type=script&lang=js&"
import style0 from "./TwIpDnDetailInner.vue?vue&type=style&index=0&id=17afb31e&lang=scss&scoped=true&"
import style1 from "./TwIpDnDetailInner.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17afb31e",
  null
  
)

export default component.exports